
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.625 8.944V6.416h21.75v2.528H3.625zM3.625 15.264h21.75v-2.528H3.625v2.528zM3.625 21.583h21.75v-2.528H3.625v2.528z","fill":"#6D6D6D"}})])
          )
        }
      }
    